import React, { useEffect, useRef } from 'react'
import { Grid, Typography, useMediaQuery } from '@material-ui/core'
import Provider from './Provider'
import { Section, BecomeExpertIn, Expertise, AsyncResponsesLoading } from 'components'
import useStyles from './Styles'
import { IImGoodAtView, IImGoodAtLinker } from './Interface'
import { theme } from 'config/constants/theme/theme'

const ImGoodAtPage: React.FC<IImGoodAtView> = ({
  disabled,
  questions,
  onAddExpertise,
  onAddBecomeExpertIn,
  onAddExpertiseTag,
  onBecomeExpertInItemChange,
  onEditBecomeExpertIn,
  onEditExpertise,
  onExpertiseTagLevelChange,
  onExpertiseTagTitleChange,
  onExpertiseTitleChange,
  onRemoveExpertise,
  onRemoveBecomeExpertIn,
  onRemoveExpertiseTag,
  onSubmitBecomeExpertIn,
  onSubmitExpertise,
  state
}) => {
  const classes = useStyles({})
  const refBecomeExpertInSection = useRef()
  const refExpertiseSection = useRef()
  const downSM = useMediaQuery(theme.breakpoints.down('sm'))

  // TODO: Move it to the provider
  useEffect(() => {
    const listener = async (evt: any) => {
      if (disabled) {
        return
      }
      // If it is a click event and is not inside of the expertise section
      if (
        refExpertiseSection.current &&
        document.contains(evt.target) &&
        // @ts-ignore: Object is possibly 'null'
        refExpertiseSection.current.contains(evt.target) &&
        state.expertiseEditingIndex > -1
      ) {
        await onSubmitExpertise()
      }

      // If it is a click event and is not inside of the become expert in section
      if (
        refBecomeExpertInSection.current &&
        document.contains(evt.target) &&
        // @ts-ignore: Object is possibly 'null'
        !refBecomeExpertInSection.current.contains(evt.target) &&
        state.becomeExpertInEditingIndex > -1
      ) {
        await onSubmitBecomeExpertIn()
      }
    }
    window.addEventListener('click', listener)
    return () => {
      window.removeEventListener('click', listener)
    }
  }, [state, onSubmitBecomeExpertIn, onSubmitExpertise])

  return (
    <Grid container direction={'column'}>
      <Section borderRadius={{ bottomLeft: 0, bottomRight: 0 }} padding={'30px 10px'} direction={'column'}>
        {downSM && (
          <Typography>
            <label id="im-good-at-page-title" className={classes.title}>
              I am good at
            </label>
          </Typography>
        )}
        <Expertise
          ref={refExpertiseSection}
          errors={state.expertiseErrors}
          expertiseInEditModeIndex={state.expertiseEditingIndex}
          disabled={disabled}
          initialValues={state.expertise}
          rules={questions?.expertise?.rules}
          onAddExpertise={onAddExpertise}
          onEditExpertise={onEditExpertise}
          onDeleteExpertise={onRemoveExpertise}
          onAddTag={onAddExpertiseTag}
          onRemoveTag={onRemoveExpertiseTag}
          onChangeExpertiseTitle={onExpertiseTitleChange}
          onChangeExpertiseTagLevel={onExpertiseTagLevelChange}
          onChangeExpertiseTagTitle={onExpertiseTagTitleChange}
          onSubmitExpertise={onSubmitExpertise}
        />
      </Section>
      <Section
        borderRadius={{
          topLeft: 0,
          topRight: 0
        }}
        background={'#A7DDF6'}
        padding={'20px 30px 20px'}
      >
        <Grid container direction={'column'} className="i-good-at-i-want-to-get-better-section">
          <Typography>
            <label id="im-good-I-want-to-get-better-at-title" className={classes.becomeExpertIn}>
              I want to get better at
            </label>
          </Typography>
          <BecomeExpertIn
            ref={refBecomeExpertInSection}
            disabled={disabled}
            becomeExpertInItems={state.becomeExpertIn}
            indexOfItemInEditMode={state.becomeExpertInEditingIndex}
            onChange={onBecomeExpertInItemChange}
            onRemove={onRemoveBecomeExpertIn}
            onAddItem={onAddBecomeExpertIn}
            onEditItem={onEditBecomeExpertIn}
            onSubmitBecomeExpertIn={onSubmitBecomeExpertIn}
          />
        </Grid>
      </Section>
    </Grid>
  )
}

export default (props: IImGoodAtLinker) => (
  <AsyncResponsesLoading>
    <Provider {...props}>{viewProps => <ImGoodAtPage {...viewProps} />}</Provider>
  </AsyncResponsesLoading>
)
